import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { useEffect } from 'react';

export const Route = createFileRoute('/')({
  component: Component,
});

function Component() {
  const navigate = useNavigate({ from: Route.fullPath });
  const convexUserQuery = useQuery(api.auth.getCurrentUser);
  const userType = convexUserQuery.data?.userType;
  const isAuthenticated = convexUserQuery.isSuccess && userType !== null;

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    if (userType === 'superAdmin') {
      void navigate({ replace: true, to: '/a' });
      return;
    }

    if (userType === 'restaurantUser') {
      void navigate({ replace: true, to: '/r' });
    }
  }, [isAuthenticated, navigate, userType]);

  return null;
}
